import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { RaiseTicketCard } from "../../../components/admin/u1/help/RaiseTicketCard";
import { ContactCard } from "../../../components/admin/u1/help/ContactCard";
import { RecentActivity } from "../../../components/admin/u1/help/RecentActivity";
import "../../../components/common/u1/tokens.css";

/* u1 Help & Support. Visual uplift only. The ticket form's data handling is transcribed in RaiseTicketCard; the activity list reads the same... */
export default function Help() {
  const { userInfo } = useSelector((state) => state.auth);
  const stored = userInfo?.individual?.[0]?.individualSupport;

  /* The activity list, kept current without a page reload — F-109. */
  const [raisedHere, setRaisedHere] = useState([]);
  useEffect(() => {
    setRaisedHere([]);
  }, [stored]);

  const tickets = [...(stored || []), ...raisedHere];

  return (
    <div className="u1-root grid grid-cols-1 items-start gap-[22px] py-6 lg:grid-cols-[minmax(0,1fr)_340px]">
      <div className="min-w-0">
        <h2 className="m-0 text-[26px] font-bold tracking-[-.01em] text-[var(--ink)] font-sans">
          Support Center
        </h2>
        <p className="mt-1.5 mb-0 max-w-[560px] text-[14.5px] leading-[1.5] text-[var(--ink-2)] font-sans">
          Raise a ticket for anything on the platform — claiming, verification,
          payments or a glitch. Our team replies within one working day.
        </p>

        <RaiseTicketCard
          className="mt-6"
          onRaised={(ticket) => ticket && setRaisedHere((prev) => [...prev, ticket])}
        />
      </div>

      <aside className="flex min-w-0 flex-col gap-4">
        <ContactCard />
        {/* Newest first: the payload is in creation order, and the ticket a
            viewer just raised is the one they came back to check. */}
        <RecentActivity tickets={[...tickets].reverse()} />
      </aside>
    </div>
  );
}
